let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("32vaB")).then(() => parcelRequire('il84e'));